import { memo, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { useAuthContext } from "../../../app/providers/contextIndex";

const TopbarAuthButtons = memo(({ onOpenLogin, onLogout }) => {
  const navigate = useNavigate();
  const accountBtnRef = useRef(null);
  const accountMenuRef = useRef(null);
  const { appCanal, appUser, appPerfil, appRolCredito } = useAuthContext();

  const accountMenuItems = useMemo(() => {
    const items = [];

    items.push({
      label: appCanal + " - " + appPerfil + " " + appRolCredito, 
      icon: "pi pi-home",
      command: () => navigate("/"),
    });
   

    items.push({ separator: true });
    
    items.push({
      label: "Mi cuenta",
      icon: "pi pi-user",
      command: () => navigate("/mi-cuenta"),
    });

    items.push({ separator: true });

    items.push({
      label: "Salir",
      icon: "pi pi-sign-out",
      className: "landing-account-menu-logout",
      command: onLogout,
    });
    return items;
  }, [appCanal, appPerfil, appRolCredito, navigate, onLogout]);

  return (
    <div className="landing-navbar-actions landing-navbar-actions--header">

      {appUser ? (
        <div className="landing-account-menu-wrapper">
          <Button
            ref={accountBtnRef}
            className="border-1 surface-border shadow-1"
            icon="pi pi-user"
            label={appUser}
            outlined
            onClick={(e) => accountMenuRef.current?.toggle(e)}
            aria-haspopup
          />
          <Menu model={accountMenuItems} popup ref={accountMenuRef} />
        </div>
      ) : (
        <Button
          className="border-1 surface-border shadow-1 mr-2"
          onClick={onOpenLogin}
          icon="pi pi-user mr-2"
          severity="success"
          label="Ingresar / Registrar"
        />
      )}
    </div>
  );
});

export default TopbarAuthButtons;
